// Paleta de colores y configuraciones visuales del gráfico matching exact reference design
export const CHART_THEME = {
  colorCreados: '#2563eb', // Royal Blue vibrante
  colorPendientes: '#f59e0b', // Amber / Naranja vibrante
  colorResueltos: '#059669', // Emerald Green vibrante
  axisLineColor: '#e2e8f0',
  axisTextColor: '#475569',
  axisSplitColor: '#f1f5f9',
  tooltipBg: 'rgba(15, 23, 42, 0.9)',
  tooltipBorder: '#334155',
  tooltipText: '#ffffff'
};

export const TOOLTIP_CONFIG = {
  trigger: 'axis',
  backgroundColor: CHART_THEME.tooltipBg,
  borderColor: CHART_THEME.tooltipBorder,
  textStyle: { color: CHART_THEME.tooltipText, fontSize: 12 },
  axisPointer: {
    type: 'shadow',
    shadowStyle: {
      color: 'rgba(241, 245, 249, 0.6)'
    }
  }
};

export const GRID_CONFIG = {
  left: '3%',
  right: '4%',
  bottom: '10%',
  top: '18%',
  containLabel: true
};

export const getXAxisConfig = (data = [], isDark = false) => ({
  type: 'category',
  data,
  axisLine: { lineStyle: { color: isDark ? '#2b3035' : CHART_THEME.axisLineColor } },
  axisTick: { show: false },
  axisLabel: {
    color: isDark ? '#94a3b8' : CHART_THEME.axisTextColor,
    fontSize: 11,
    margin: 12
  }
});

export const getYAxisConfig = (maxVal = 2, isDark = false) => ({
  type: 'value',
  minInterval: 1,
  max: Math.max(2, maxVal + 1),
  splitLine: {
    lineStyle: {
      color: isDark ? 'rgba(255, 255, 255, 0.05)' : CHART_THEME.axisSplitColor,
      type: 'dashed'
    }
  },
  axisLine: { show: false },
  axisTick: { show: false },
  axisLabel: { color: isDark ? '#64748b' : '#94a3b8', fontSize: 11 }
});

export const getSeriesConfig = (
  dataCreados = [],
  dataResueltos = [],
  dataPendientes = [],
  currentHourKey = null
) => {
  const markLineConfig = currentHourKey
    ? {
        symbol: ['none', 'circle'],
        symbolSize: 6,
        symbolOffset: [0, 0],
        itemStyle: {
          color: '#64748b'
        },
        label: {
          show: false
        },
        lineStyle: {
          type: 'dashed',
          color: '#cbd5e1',
          width: 1.5
        },
        data: [{ xAxis: currentHourKey }]
      }
    : undefined;

  return [
    {
      name: 'Creados',
      type: 'bar',
      barWidth: 12,
      barGap: '20%',
      itemStyle: {
        color: CHART_THEME.colorCreados,
        borderRadius: [4, 4, 4, 4]
      },
      label: {
        show: true,
        position: 'top',
        distance: 5,
        color: CHART_THEME.colorCreados,
        fontWeight: '700',
        fontSize: 11,
        formatter: params => (params.value > 0 ? params.value : '')
      },
      data: dataCreados
    },
    {
      name: 'Pendientes',
      type: 'bar',
      barWidth: 12,
      itemStyle: {
        color: CHART_THEME.colorPendientes,
        borderRadius: [4, 4, 4, 4]
      },
      label: {
        show: true,
        position: 'top',
        distance: 5,
        color: CHART_THEME.colorPendientes,
        fontWeight: '700',
        fontSize: 11,
        formatter: params => (params.value > 0 ? params.value : '')
      },
      data: dataPendientes
    },
    {
      name: 'Resueltos',
      type: 'bar',
      barWidth: 12,
      itemStyle: {
        color: CHART_THEME.colorResueltos,
        borderRadius: [4, 4, 4, 4]
      },
      label: {
        show: true,
        position: 'top',
        distance: 5,
        color: CHART_THEME.colorResueltos,
        fontWeight: '700',
        fontSize: 11,
        formatter: params => (params.value > 0 ? params.value : '')
      },
      markLine: markLineConfig,
      data: dataResueltos
    }
  ];
};

/**
 * Genera la configuración visual de ECharts a partir de los datos procesados.
 */
export const buildChartOption = (
  xCategories = [],
  dataCreados = [],
  dataResueltos = [],
  dataPendientes = [],
  currentHourKey = null,
  isDark = false
) => {
  const maxVal = Math.max(
    ...dataCreados.map(v => Number(v) || 0),
    ...dataPendientes.map(v => Number(v) || 0),
    ...dataResueltos.map(v => Number(v) || 0),
    0
  );

  return {
    tooltip: {
      ...TOOLTIP_CONFIG,
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: isDark ? 'rgba(255, 255, 255, 0.04)' : 'rgba(241, 245, 249, 0.6)'
        }
      }
    },
    legend: { show: false }, // Manejado en HTML superior para control total del diseño
    grid: GRID_CONFIG,
    xAxis: getXAxisConfig(xCategories, isDark),
    yAxis: getYAxisConfig(maxVal, isDark),
    series: getSeriesConfig(dataCreados, dataResueltos, dataPendientes, currentHourKey)
  };
};
